import { Component, OnInit, Input } from '@angular/core';
import { StatusService } from 'app/services/status.service';
import { AuthWebService } from 'app/services/authweb.service';
import { CarrierService } from 'app/services/carrier.service';
import { PermitService } from 'app/services/permit.service';
import { ToastrService } from 'ngx-toastr';
import { ApplicationService } from 'app/services/application.service';
import { CurrencyFormat } from 'app/pipes/currencyFormat.pipe';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { environment } from 'environments/environment';

declare var $;

@Component({
  selector: 'correspondence',
  templateUrl: './permit-correspondence.component.html',
  styleUrls: ['./permit-correspondence.component.css']
})
export class PermitCorrespondenceComponent implements OnInit {

  @Input('ctrlData') ctrlData: any;
  description: any;
  gridload:boolean=true;
  approvalRes:any;
  statuses: any = [];
  emailContacts:any = {};
  crspdType:any="";
  @Input() dataCntrl: any;
  message = "Processing. Please wait...";
  isLoading : boolean = false;
  status:any;
  statusId:any="";
  addInfo: boolean = false;
  addInfoStatus: any = [];
  headingMsg: string = "";
  aUser: any = {};
  constructor(private statusService: StatusService, private authWebService: AuthWebService,
    private carrierService: CarrierService,private permitService:PermitService,private toastr:ToastrService,
    private applicationService:ApplicationService,private utility:UtilityServiceService
    ,private router: Router, private activeRoute: ActivatedRoute,) {
        this.activeRoute.params.subscribe((params: Params) => {
        this.getApplication(params['id']);
        this.aUser = environment.authWebApi.userData.User;
        });
        
      
     }

  ngOnInit() {
    this.statusId=this.utility.approveStatusId
    this.gridload=false;
    this.retrieveAddInfoStatus();
    this.retrieveSubmitStatus();

    if (this.utility.btnAction == 1) {
      this.headingMsg = "- Additional Information";
      this.addInfo = true;
      
    } else if (this.utility.btnAction == 5) {
      this.headingMsg = "- Change Status";
    }
  }
  changes(){

 

  }

  statusUpdate(){
    console.log(this.approvalRes.status_id);


    if(this.approvalRes.status_id==93 || this.approvalRes.status_id== 11){
      this.description = this.authWebService.userData.Configurations.find(config => config.Code == "CarrierStatus93").Value.replace("helpdesk@cbrta.co.za", this.aUser.EmailAddress);
    }else
    {
      this.description = "";
    }

  }

  getStatus(){
    this.statusService.getAll().subscribe((x:any) => {      
      
      this.statuses = x.filter(s=>s.id != 51);
      this.statuses.sort((a,b) => a.sort_order > b.sort_order ? 1 : -1 &&  a.group_code > b.group_code ? 1 : -1 &&  a.id > b.id ? 1 : -1);  

      this.status = this.statuses.find(x => x.id == this.approvalRes.status_id);
      console.log("STATUS",this.status);

      var tmpStatuses: any = [];
      this.statuses.forEach(y => {
        if (y.group_code >= this.status.group_code ) {           
          tmpStatuses.push(y);            
        }        
      });
      this.statuses = tmpStatuses;
      //console.log(this.statuses);

      

    })
  }

  onSAveAndSend = () => {
    this.isLoading = true;

    if(this.approvalRes.status_id == 11 && this.status.id==13 )
      {
        this.toastr.warning("The current application status cannot be changed to 'Submitted'");
        this.isLoading = false;
        return;
      }
      
    if (this.utility.btnAction == 1) {
      
      this.approvalRes.status_id = this.addInfoStatus.id;
      this.approvalRes.status = this.addInfoStatus.code;      
    }
    let body = {email : this.crspdType, body: this.description}
    let desc = "";
    this.applicationService.putApplication(this.approvalRes).subscribe(res=>{
        //console.log(res);
        this.sendEmail(body);
    });
  }

  sendEmail(body){
    this.permitService.sendApproveEmail(body).subscribe(result => {
      this.isLoading = false;
      this.router.navigateByUrl('permit/approval')
      this.toastr.success('Mail Sent Successfully');
    });
  }

  selectUser(email){
    this.crspdType=email;
  }

  retrieveSubmitStatus = () => {
    //console.log(this.utility.btnAction);
    // this.description = this.authWebService.userData.Configurations.find(config => config.Code == "ConfirmEmail2").Value;
    if (this.authWebService.userData) {
      switch (this.utility.btnAction) {
        case 1:
          this.description = this.authWebService.userData.Configurations.find(config => config.Code == "AdditionalEmail2").Value.Value.replace("helpdesk@cbrta.co.za", this.aUser.EmailAddress);;
          break;
        case 2:
          this.description = this.authWebService.userData.Configurations.find(config => config.Code == "ConfirmEmail2").Value;
          break;
        default:
          break;
      }


    }
    //console.log(this.authWebService.userData.Configurations.find(config => config.Code == "AdditionalEmail2").Value)
    //console.log(this.authWebService.userData.Configurations.find(config => config.Code == "ConfirmEmail3").Value)

  }

  getCorrespondenceTo(id) {
    this.carrierService.correspondenceToByCarrierId(id).subscribe(x => {
      this.emailContacts = x;
      //console.log(this.emailContacts);
    })
  }
 
  getApplication(id){
    this.isLoading =true;

      this.applicationService.getById(id).subscribe(data =>{
        //console.log(data);
        this.isLoading =false;

        this.approvalRes = data;
        this.getCorrespondenceTo(this.approvalRes.carrier_id);
        this.getStatus();
        if(this.utility.btnAction==1){
          if(this.utility.actionStatus!=0){
            // this.approvalRes.status_id=this.utility.actionStatus;
            this.description = this.authWebService.userData.Configurations.find(config => config.Code == "CarrierStatus93").Value.replace("helpdesk@cbrta.co.za", this.aUser.EmailAddress);
        }
        }else if(this.approvalRes.status_id!=21 && this.approvalRes.status_id!=31 && this.utility.btnAction==2){
          if(this.utility.actionStatus!=0){
              // this.approvalRes.statusId=this.utility.actionStatus;
              // this.approvalRes.status_id=this.utility.actionStatus;
          }
        }
      },err =>{
        this.isLoading =false;
      })
    
  }
  redirectList(){
    let prevUrl = localStorage.getItem('previousUrl');
    this.router.navigate([prevUrl])
    // this.router.navigate(['/permit/approval'])
  }

  retrieveAddInfoStatus() {
    this.statusService.getAll().subscribe((all_statuses:any) => {
      let allStatuses = all_statuses;
      let additionalInformation = allStatuses.find(status => status.id == 2)
      if (additionalInformation != undefined && additionalInformation != null) {
        this.addInfoStatus.code = additionalInformation.code;
        this.addInfoStatus.id = additionalInformation.id;
      }
    });
  }

}
